import { EvaluatedRights } from '../../interfaces/Rights';
import Images from '../Images/Images';
import '../styles.css';
import Evaluations from '../Evaluations/Evaluations';
import { Period } from '../../interfaces/Periods';

interface IAccessToRigths extends EvaluatedRights {
    periodSelected: Period;
}

const AccessToRigths = ({ color, icono, icono_base64, titulo, evaluaciones, periodSelected }: IAccessToRigths) => {

    const periodEvaluations = evaluaciones?.[periodSelected?.value] || {};

    //iluminar solo lo de atras
    return (
        <div className="relative h-fit w-full group rounded-sm hover:shadow-custom-dual">
            <div className='absolute w-full h-full rounded-sm transition-all duration-300 group-hover:brightness-[90%]' style={{ backgroundColor: color }}>
                <div className="imagen-bg-card-rights rounded-sm "></div>
            </div>

            <div className='w-full p-4 relative z-10'>
                <div className='flex items-center gap-4 pb-4'>
                    <Images imagen={icono} imagen_base64={icono_base64 ?? ''} className="w-[4.25rem] h-[3.375rem] object-contain transition-all duration-500 group-hover:scale-110" />                    <h2 className='text-hmedium text-primary-100'>{titulo}</h2>
                </div>
                <Evaluations
                    arithmeticalEvaluation={
                        periodEvaluations.suma_aritmetica !== undefined && periodEvaluations.suma_aritmetica !== null
                            ? [periodEvaluations?.suma_aritmetica]
                            : []
                    }
                    showArithmeticalIndicators={true}
                    arithmeticalEvaluationLabel='Indicadores por estado'
                    trivalentEvaluation={
                        periodEvaluations.evaluacion_trivalente !== undefined && periodEvaluations.evaluacion_trivalente !== null
                            ? periodEvaluations?.evaluacion_trivalente
                            : null
                    }
                    trivalentStateStyle='text-llarge text-primary-10'
                    evaluationStyle='text-llarge'
                    backgroundColorCard='#FFFFFF'
                    showTitleEvaluation={false}
                    labelArithmeticalEvaluationStyle='text-llarge text-primary-10 text-center'
                />
            </div>
        </div>
    );
};

export default AccessToRigths;